import { DESTINATIONS } from '@elementary/common-ui/constants/queryKeys';

// A request without destinations must never share a key with one that has
// them: sharing forces every consumer that doesn't need `alertDestinations`
// (the query's most expensive field) to refetch and wait for it whenever the
// richer key is invalidated.
export const resolveDestinationsQueryKey = (
  baseKey: (string | undefined)[],
  includeAlertDestinations: boolean,
): (string | undefined)[] =>
  includeAlertDestinations ? [...baseKey, DESTINATIONS] : baseKey;
